import { Tooltip } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import * as S from './ImageButton.styled';

function ImageButton({ type, shape, imagem, uri, alt, tooltip }) {
  function onClick() {
    if (uri) {
      const redirect = !uri.match(/http(s)*:\/\//g) ? `http://${uri}` : uri;
      window.open(redirect);
    }
  }

  return (
    <Tooltip title={tooltip}>
      <S.ImageButton
        type={type || 'primary'}
        shape={shape}
        onKeyDown={event => {
          if (event.keyCode === 13) onClick();
        }}
        onClick={onClick}
        tabIndex={0}
        aria-label={tooltip || alt || 'Abrir link'}
      >
        <S.Image
          src={`data:image/png;base64, ${imagem}`}
          alt={alt || tooltip || 'Imagem'}
        />
      </S.ImageButton>
    </Tooltip>
  );
}

export default withRouter(ImageButton);
